import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/images/zy-1.png'
import _imports_1 from '@/assets/images/zy-2.png'


const _hoisted_1 = { class: "translation-con" }
const _hoisted_2 = { class: "tip" }
const _hoisted_3 = { class: "box" }
const _hoisted_4 = {
  key: 0,
  class: "header-img",
  src: _imports_0
}
const _hoisted_5 = {
  key: 1,
  class: "header-img",
  src: _imports_1
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 3,
  class: "message"
}
const _hoisted_8 = {
  key: 1,
  class: "hbb-trans-noData"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "录音尚未转译为文本，约5分钟后自动转译文本可查看。", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "mas-audio" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_no_data_view = _resolveComponent("no-data-view")!
  const _component_mas_audio = _resolveComponent("mas-audio")!
  const _component_mas_modal = _resolveComponent("mas-modal")!

  return (_openBlock(), _createBlock(_component_mas_modal, {
    visible: _ctx.recordingTranslationStatus,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.recordingTranslationStatus) = $event)),
    title: "录音转译",
    customClass: "hbb-recording-translation-view",
    closeOnClickModal: false,
    width: "800px",
    customFooterBtns: "",
    closeIcon: ""
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.callInfo.name) + " " + _toDisplayString(_ctx.callInfo.phone), 1),
            _createElementVNode("span", null, " 呼叫时间：" + _toDisplayString(_ctx.callInfo.callTime || "00:00:00") + "，通话时长：" + _toDisplayString(_ctx.callInfo.callDuration || "00:00:00"), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          (_ctx.callLogInfo.contextVOList.length>0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.callLogInfo.contextVOList.length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.callLogInfo.contextVOList, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["item", {
                  right: item.spk === _ctx.user,
                  left: item.spk === _ctx.customer,
                }]),
                        key: index
                      }, [
                        (item.spk === _ctx.user)
                          ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                          : _createCommentVNode("", true),
                        (item.spk === _ctx.customer)
                          ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                          : _createCommentVNode("", true),
                        (item.spk === _ctx.user)
                          ? (_openBlock(), _createElementBlock("p", {
                              key: 2,
                              class: "message",
                              innerHTML: _ctx.detectionKeyword(item.context)
                            }, null, 8, _hoisted_6))
                          : (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(item.context), 1))
                      ], 2))
                    }), 128))
                  : (_openBlock(), _createBlock(_component_no_data_view, {
                      key: 1,
                      title: "暂无转译内容"
                    }))
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_mas_audio, {
          source: _ctx.callLogInfo.record,
          duration: _ctx.callLogInfo.talkTimeLength
        }, null, 8, ["source", "duration"])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}